import React from 'react';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import { Grid, Row, Col } from 'components/Grid';
import style from './style.scss';
import EnterCarDetailsForm from 'components/EnterCarDetailsForm';
import { Ads, Banner, Mpu, Overlay, Overlay2 } from 'components/Ads';
import DataLayerPush from 'components/DataLayerPush';
export default class EnterCarDetailsPage extends React.Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired
  };

  render() {
    const { history } = this.props;
    const adUnitLevel3 = 'home';
    const dataLayerData = {
      content_type: 'valuations',
      navigation_section: 'step 1'
    };

    return (
      <Ads>
        <MetaTags>
          <title>Free Car Valuation - How much is my car worth?</title>
          <script type="application/ld+json">
            {`{
                "@context": "https://schema.org/",
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "item": {
                      "@id": "https://www.whatcar.com",
                      "name": "Home"
                    }
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "item": {
                      "@id": "https://www.whatcar.com/car-valuation",
                      "name": "Car valuations"
                    }
                  }
                ]
              }`}
          </script>
        </MetaTags>
        <div className={style.bannerAd}>
          <Banner id="gpt_7294_masthead1" adUnitLevel3={adUnitLevel3} />
        </div>
        <div className={style.pageContent}>
          <Grid className={style.grid}>
            <Row>
              <Col colLg={8} colMd={7} colXs={12}>
                <div className={style.breadcrumb}>
                  <a href="https://www.whatcar.com">Home</a> &gt; Car valuations
                </div>
                <h1 className={style.mainHeading}>Free car valuation</h1>
                <p className={style.introText}>
                  What Car?’s car valuations are the most up-to-date and
                  accurate guides to how much your car is worth. It’s free and
                  immediate, plus we’ll email you a valuation certificate.
                </p>
                <div className={style.formContainer}>
                  <EnterCarDetailsForm history={history} />
                </div>
              </Col>
              <Col colLg={4} colMd={5} colXs={12}>
                <div className={style.rail}>
                  <Mpu
                    id="gpt_7294_mpu_flexible1"
                    adUnitLevel3={adUnitLevel3}
                  />
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
        <Overlay id="gpt_7294_overlay" adUnitLevel3={adUnitLevel3} />
        <Overlay2 id="gpt_7294_overlay2" adUnitLevel3={adUnitLevel3} />
        {dataLayerData && (
          <DataLayerPush event={'view_page'} {...dataLayerData} />
        )}
      </Ads>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EnterCarDetailsPage/EnterCarDetailsPage.js